import React, { useState } from 'react'
import { Modal, Switch, message, Icon } from 'antd'
import { updateRule } from '../../../../services/api/3dApi'
import { Promise } from 'bluebird'

function BulkActionStatus(props) {
    const { selectedItems = [], listRule = [], resetAction, reset } = { ...props }
    const [loading, setLoading] = useState(false)
    const [showModal, setShowModal] = useState(true)
    const [status, setStatus] = useState(false)

    const toggleModal = () => {
        setShowModal(!showModal)
        if (showModal) resetAction()
    }

    const onChangeStatus = (value) => {
        setStatus(value)
    }

    const handleChangeStatusRule = async (item, status) => {
        try {
            const { data: res } = await updateRule(item._id, { is_active: status })
            const { success, error: mess, data } = { ...res }
            if (!success) {
                return { success: success, message: mess }
            }
            return { data, success: success }

        } catch (e) {
            const { data: resErr } = { ...e.response }
            const { message: ErrMess } = { ...resErr }
            return { success: false, message: ErrMess || e.message }
        }
    }

    const showMessage = (item) => {
        if (!!item.error) {
            return (
                <span className="d-sm-block text-danger">{
                    item.error
                }</span>
            )
        }

        if (item.success === true) {
            return <span className="d-sm-block text-success">Change status successfully!</span>
        }
        return <span className="d-sm-block">Waiting...</span>

    }

    const onOk = async () => {
        setLoading(true)
        const listItems = listRule.filter(i => selectedItems.includes(i._id))
        let processed = []
        try {
            await Promise.all(listItems.map(async item => {
                const response = await handleChangeStatusRule(item, status)

                const { data, success, message } = response
                if (!success) return processed.push({ ...item, error: message, processing: false })

                return processed.push({ ...item, success: true, processing: false })
            }))
            setShowModal(false)

            let newListSuccess = []
            let newListError = []

            processed.map(process => {
                if (process.success === true) {
                    return newListSuccess.push(process)
                }

                if (process.error.length > 0) {
                    return newListError.push(process)
                }
            })
            setLoading(false)
            Modal.info({
                title: 'Kết quả On/Off Status',
                icon: false,
                style: { minWidth: '45%' },
                content: (
                    <>
                        <h5>List processing <span>{selectedItems.length}</span> items</h5>
                        {
                            (newListSuccess.length > 0 || newListError.length > 0) &&
                            <div className="Results">
                                <div className="ResultSuccess">
                                    Success: <span>{newListSuccess.length}</span> items
                                </div>
                                <div className="ResultError">
                                    Error: <span>{newListError.length}</span> items
                                </div>
                            </div>
                        }

                        <div className="ListProcessing">
                            <ul>
                                {
                                    !!processed && processed.length > 0 && processed.map(item => (
                                        <div key={item._id} className="ItemGenLabel d-sm-flex mb-2 pb-2">
                                            <div className="IconStatus mr-2">
                                                {!!item.success && (
                                                    <Icon type="check-circle" theme="twoTone" twoToneColor="#52c41a" />
                                                )}
                                                {!!item.error && (
                                                    <Icon type="exclamation-circle" theme="twoTone" twoToneColor="#eb2f96" />
                                                )
                                                }
                                            </div>
                                            <div className="ContentGenLabel">
                                                <strong>Rule priority: {item.priority}</strong>
                                                {showMessage(item)}
                                            </div>
                                        </div>
                                    )
                                    )
                                }
                            </ul>
                        </div>
                    </>
                ),
                onOk: () => {
                    resetAction()
                    reset()
                },
                okText: 'Đóng'
            })
        } catch (error) {
            message.error(error.message)
        }
    }

    return (
        <>
            <div className="bulk-action-status">
                On/Off status
            </div>
            <Modal
                title='On/Off status'
                visible={showModal}
                onCancel={toggleModal}
                onOk={onOk}
                okButtonProps={{ disabled: loading }}
                cancelButtonProps={{ disabled: loading }}
                confirmLoading={loading}
            >
                <div className='d-flex align-items-center'>
                    <h3 className='mb-0 mr-5'>Status</h3>
                    <Switch
                        checkedChildren='On'
                        unCheckedChildren='Off'
                        size={'default'}
                        checked={status}
                        onChange={onChangeStatus}
                    />
                </div>
            </Modal>
        </>
    )
}

export default BulkActionStatus